export default class UrlUtils {
  static updateSearchParameter(key, value, reloadPage = false) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const paramExists = searchParams.has(key);

    if (paramExists) {
      const currentValue = searchParams.get(key);
      if (currentValue === value) {
        return;
      }
    }
    else if (!value) {
      return;
    }

    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }

    let newUrl = url.pathname;

    const searchParamsStr = searchParams.toString();
    if (searchParamsStr) {
      newUrl += `?${searchParamsStr}`;
    }

    window.history.pushState(null, '', newUrl);

    if (reloadPage) {
      window.location.reload();
    }
  }

  static isSameSiteOrMyChartUrl(url) {
    const targetUrl = new URL(url);
    const currentUrl = new URL(window.location.href);
    const myChartUrl = drupalSettings?.luminis?.oauthMychartUrl ? new URL(drupalSettings?.luminis?.oauthMychartUrl) : '';

    const allowedHostnames = [currentUrl.hostname];
    if (myChartUrl) {
      allowedHostnames.push(myChartUrl.hostname);
    }

    // if on login page of current host return false
    const loginPagePattern = /^\/[a-z]{2}\/login\/?$/i;
    const isTargetUrlSetToHostLoginPage = loginPagePattern.test(targetUrl.pathname) &&
      targetUrl.hostname === currentUrl.hostname;
    if (isTargetUrlSetToHostLoginPage) {
      return false;
    }

    return allowedHostnames.includes(targetUrl.hostname);
  }

  static isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Copy all query string parameters from the source URL to the target URL.
   * This does not remove any existing query string parameters from the target
   * URL.
   *
   * @param {string} sourceUrlHref the URL to copy query string parameters from
   * @param {string} targetUrlHref the URL to copy query string parameters to
   * @returns {string}
   */
  static copyQueryString(sourceUrlHref, targetUrlHref) {
    const sourceUrl = new URL(sourceUrlHref);
    const targetUrl = new URL(targetUrlHref);

    const sourceSearchParams = sourceUrl.searchParams;

    for (const [key, value] of sourceSearchParams.entries()) {
      targetUrl.searchParams.append(key, value);
    }

    return targetUrl.href;
  }
}
